import { useState } from "react";
import "./BeforeAfterToolCard.css";
import bikeBefore from "../../assets/before_after/bike_before.png";
import bikeAfter from "../../assets/before_after/bike_after.png";

/**
 * Tool card: left = before image, right = after image.
 * On hover the divider sweeps like a short before/after video, then settles at center.
 */
const BeforeAfterToolCard = ({
  label,
  beforeImage = bikeBefore,
  afterImage = bikeAfter,
  onClick,
  clickable = true,
  badge = null,
  comingSoon = false,
  proIcon = null,
}) => {
  const [animating, setAnimating] = useState(false);

  const handleEnter = () => {
    setAnimating(false);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setAnimating(true));
    });
  };

  const handleLeave = () => {
    setAnimating(false);
  };

  const canActivate = clickable && !comingSoon;

  const activate = () => {
    if (canActivate && typeof onClick === "function") onClick();
  };

  return (
    <div
      className={`ba-tool-card${canActivate ? " ba-tool-card--clickable" : ""}${
        comingSoon ? " ba-tool-card--soon" : ""
      }${animating ? " ba-tool-card--animating" : ""}`}
      role={canActivate ? "button" : undefined}
      tabIndex={canActivate ? 0 : undefined}
      onClick={activate}
      onKeyDown={
        canActivate
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                activate();
              }
            }
          : undefined
      }
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      {comingSoon ? (
        <span className="ba-tool-card__soon">soon</span>
      ) : null}
      <div className="ba-tool-card__media" aria-hidden="true">
        {badge ? <span className="ba-tool-card__badge">{badge}</span> : null}

        <img
          className="ba-tool-card__img ba-tool-card__img--after"
          src={afterImage}
          alt=""
          draggable={false}
        />
        <img
          className="ba-tool-card__img ba-tool-card__img--before"
          src={beforeImage}
          alt=""
          draggable={false}
        />

        <div className="ba-tool-card__handle">
          <span className="ba-tool-card__handle-line" />
        </div>
      </div>
      <div className="ba-tool-card__footer">
        <div className="ba-tool-card__title-row">
          <span className="ba-tool-card__label">{label}</span>
          {proIcon ? (
            <img src={proIcon} alt="" className="ba-tool-card__pro" title="Pro" />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterToolCard;
